import { X } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface AnalysisCardProps {
  icon: LucideIcon
  title: string
  content: string
  previewLength?: number
  isExpanded: boolean
  onClick: () => void
}

export const AnalysisCard = ({
  icon: Icon,
  title,
  content,
  previewLength = 300,
  isExpanded,
  onClick,
}: AnalysisCardProps) => {
  const displayContent = isExpanded
    ? content
    : `${content.substring(0, previewLength)}...`

  return (
    <div
      onClick={isExpanded ? undefined : onClick}
      className={`
        relative flex gap-4 p-6 bg-white border border-gray-200 rounded-lg 
        transition-all duration-300 ease-in-out ${isExpanded ? 'cursor-default' : 'cursor-pointer'}
        hover:shadow-lg hover:border-gray-300
        ${isExpanded ? 'shadow-xl' : 'shadow-sm'}
      `}
    >
      {/* Icon column */}
      <div className="flex-shrink-0">
        <Icon className="w-8 h-8" />
      </div>

      {/* Title and content column */}
      <div className="flex flex-col gap-3 flex-1">
        <div className="flex items-center justify-between">
          <h3 className="font-extrabold text-3xl">{title}</h3>
          {isExpanded && (
            <button
              onClick={e => {
                e.stopPropagation()
                onClick()
              }}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>
        <div
          className={`text-sm text-gray-700 leading-relaxed whitespace-pre-line ${
            !isExpanded ? 'line-clamp-6' : ''
          }`}
        >
          {displayContent}
        </div>
      </div>
    </div>
  )
}
